import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";

export const useModifyQueryParams = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);

      return params.toString();
    },
    [searchParams]
  );

  const getPathWithRemainedParams = (paramToRemove: string) => {
    const params = new URLSearchParams(searchParams.toString());
    params.delete(paramToRemove);
    const paramsStr = params.toString();
    return paramsStr === "" ? pathname : pathname + "?" + paramsStr;
  };

  const isQueryParamPresent = (param: string, value: string | boolean) => searchParams.get(param) === `${value}`;

  const addQueryParam = (param: string, value: string | boolean) => {
    const newParams = createQueryString(param, `${value}`);
    router.replace(`${pathname}?${newParams}`);
  };

  const getCurrentPathWithNewParam = (param: string, value: string | boolean) => {
    const newParams = createQueryString(param, `${value}`);
    return `${pathname}?${newParams}`;
  };

  const removeQueryParam = (param: string) => {
    router.replace(getPathWithRemainedParams(param));
  };

  return {
    addQueryParam,
    removeQueryParam,
    isQueryParamPresent,
    getCurrentPathWithNewParam,
  };
};
